import { useGetCoursePlanQuery, useGetEvaluationQuery } from '@teachur/http-client';

interface EnrollmentJourneyState {
  wizardComplete: boolean;
  planSaved: boolean;
  isLoading: boolean;
}

export const useEnrollmentJourney = (): EnrollmentJourneyState => {
  const { data: evaluation, isLoading: evaluationLoading } = useGetEvaluationQuery();
  const { data: coursePlan, isLoading: planLoading } = useGetCoursePlanQuery();

  return {
    wizardComplete: evaluation?.priorEducationStatus != null,
    planSaved: (coursePlan?.plans?.length ?? 0) > 0,
    isLoading: evaluationLoading || planLoading,
  };
};
